<template>
  <rfq>
    <v-main class="guest-main">
    <v-container class="cust-main-container fill-height tw-min-h-full" fluid>

    <div class="cps-shell guest-quote-shell">
      <div class="cust-page-header">
        <div>
          <h1 class="cust-ui-title">Get a quote</h1>
          <p class="cust-ui-subtitle">
            Browse cover and generate a quote — sign in when you’re ready to buy.
          </p>
        </div>
        <router-link :to="{ name: 'SignIn', query: { portal: 'customer' } }" class="cust-ui-link cps-back-link">
          <v-icon small color="#184679">mdi-arrow-left</v-icon>
          Back to sign in
        </router-link>
      </div>

      <div class="cps-tabs" role="tablist">
        <button
          v-for="cat in categories"
          :key="cat.id"
          type="button"
          role="tab"
          :class="['cps-tab', activeCategory === cat.id ? 'cps-tab--active' : '']"
          :aria-selected="activeCategory === cat.id"
          @click="activeCategory = cat.id"
        >
          {{ cat.label }}
        </button>
      </div>
      <div class="cps-products-section">
        <div class="cps-section-heading">
          <h2>Choose your insurance</h2>
          <p>Select a product below to get a quote.</p>
        </div>

        <customer-product-tray
          variant="catalog"
          :category="activeCategory"
          :products-override="guestProducts"
          cta-label="Get Quote"
        />
      </div>
      <!-- <customer-product-tray
        variant="catalog"
        :category="activeCategory"
        :products-override="guestProducts"
        cta-label="Get Quote"
      /> -->

      <p class="cps-help-footer">
        Already have an account?
        <router-link :to="{ name: 'SignIn', query: { portal: 'customer' } }">Sign in</router-link>
        to buy cover and manage policies.
      </p>
    </div>
    </v-container>
    </v-main>
  </rfq>
</template>

<script>
import Rfq from '@/components/layout/Rfq';
import CustomerProductTray from '@/components/customer/CustomerProductTray';
import { CUSTOMER_PRODUCT_CATEGORIES } from '@/constants/customerProducts';
import { guestQuoteProducts } from '@/utils/guestQuote';

export default {
  name: 'GuestProductSelect',
  components: { Rfq, CustomerProductTray },
  data() {
    return {
      activeCategory: 'all',
      categories: CUSTOMER_PRODUCT_CATEGORIES,
      guestProducts: guestQuoteProducts(),
    };
  },
  metaInfo: { title: 'Get a quote' },
};
</script>

<style scoped src="@/assets/css/customer-product-select.css"></style>
<style src="@/assets/css/customer-ui.css"></style>
<style scoped>
.guest-main{
  background: #f4f6f9 !important;
}

.guest-quote-shell {
  padding-top: 8px;
  padding-left: 8px;
  padding-right: 8px;
  max-width: 1100px;
  margin: 0 auto;
}

.cps-products-section {
  width: 100%;
}

.cps-section-heading {
  margin-bottom: 14px;
}

.cps-section-heading h2 {
  margin: 0 0 4px;
  font-family: 'Diagramm', sans-serif;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.4;
  color: #184679;
}

.cps-section-heading p {
  margin: 0;
  font-family: 'Diagramm', sans-serif;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: #64748B;
}

@media (min-width: 960px) {
  .guest-quote-shell {
    padding-left: 16px;
    padding-right: 16px;
  }
}
</style>
